<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variants() {
      const btnVariants = [];
      if (this.secondary) {
        btnVariants.push("vw-button--secondary");
      }
      return btnVariants;
    },
  },
};
</script>

<template>
  <a :class="variants" class="vw-button">{{ label }}</a>
</template>

<style lang="scss" scoped>
button {
  border: 0;
  outline: 0;
}
.vw-button {
  align-items: center;
  background-color: var(--btn-normal-bg);
  border-radius: 0;
  border: 1px solid currentColor;
  color: var(--btn-normal-text);
  cursor: pointer;
  display: flex;
  font-family: var(--baseFont);
  font-size: 14px;
  font-weight: normal;
  height: var(--btn-height, 48px);
  letter-spacing: 1.05px;
  outline: 0;
  padding: 0 var(--btn-padding, 10px);
  text-decoration: none;
  text-transform: uppercase;
  width: max-content;
  &:hover {
    background-color: black;
    color: white !important;
  }
}
.vw-button--secondary {
  background-color: var(--primary);
  color: var(--secondary);

  &:hover {
    background-color: var(--secondary);
    color: var(--primary) !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/vw-button.vue